<div
  [ngClass]="{ '--enrollment': config.enrollmentTheme }"
  class="idp-offer-card"
  [ngClass]="orientation === 'vertical' ? '--vertical' : '--horizontal'"
>
  <div
    [ngClass]="{ '--congrats': config.congratulation }"
    class="idp-offer-card-header mx-auto"
  >
    <span class="idp-offer-card-header__image-container">
      <img
        [alt]="image?.alt"
        [ngClass]="'--' + imageStyles?.width + '-width'"
        [src]="image?.src"
        class="idp-offer-card-header__image"
        data-cy="idp-offer-card-image"
      />
    </span>
    <h2
      *ngIf="config.showHeadline"
      [style.background-color]="headlineStyles?.backgroundColor"
      [style.color]="headlineStyles?.fontColor"
      [style.font-family]="headlineStyles?.fontType"
      [style.font-size]="headlineStyles?.fontSize"
      class="idp-offer-card-header__headline"
      data-cy="idp-offer-card-headline"
    >
      {{ headline }}
    </h2>
    <h3
      *ngIf="!config.showHeadline || displaySecondaryHeader"
      [innerHTML]="offer"
      [style.color]="offerStyles?.fontColor"
      [style.font-family]="offerStyles?.fontType"
      [style.font-size]="offerStyles?.fontSize"
      class="idp-offer-card-header__welcome-text"
      data-cy="idp-offer-card-welcome"
    ></h3>
  </div>
  <div class="idp-offer-card-content">
    <span
      *ngIf="config.showOffer"
      [ngClass]="{
        'idp-offer-card-content--border': config.showDetails,
        'idp-offer-card-content--transform':
          !config.showHeadline && !config.showDetails,
        'idp-offer-card-content--congrats': config.congratulation
      }"
      [style.border-bottom-color]="containerStyles?.borderColor"
      id="offer-card-content-header"
    >
      <h2
        *ngIf="config.showHeadline"
        [innerHtml]="headline | safe : 'html'"
        [style.background-color]="headlineStyles?.backgroundColor"
        [style.color]="headlineStyles?.fontColor"
        [style.font-family]="headlineStyles?.fontType"
        [style.font-size]="headlineStyles?.fontSize"
        class="idp-offer-card-content__headline"
        data-cy="idp-offer-card-content-title"
      ></h2>
      <h3
        [innerHTML]="offer"
        [ngClass]="{
          '--display': !config.showHeadline,
          '--congrats': config.congratulation
        }"
        [style.color]="offerStyles?.fontColor"
        [style.font-family]="offerStyles?.fontType"
        [style.font-size]="offerStyles?.fontSize"
        class="col-12 idp-offer-card-content__offer"
        data-cy="idp-offer-card-content-offer"
      ></h3>
      <p
        *ngIf="config.showBenefit"
        [ngClass]="{ '--congrats': config.congratulation }"
        [style.color]="benefitStyles?.fontColor"
        [style.font-family]="benefitStyles?.fontType"
        [style.font-size]="benefitStyles?.fontSize"
        class="col-12 idp-offer-card-content__benefit"
        data-cy="idp-offer-card-benefit"
      >
        {{ benefit }}
      </p>
    </span>
    <ng-container *ngIf="config.showDetails">
      <p
        [style.color]="feeStyles?.fontColor"
        [style.font-family]="feeStyles?.fontType"
        [style.font-size]="feeStyles?.fontSize"
        class="idp-offer-card-content__fee"
        data-cy="idp-offer-card-fee"
      >
        {{ fee }}
      </p>
      <p
        [style.color]="detailsStyles?.fontColor"
        [style.font-family]="detailsStyles?.fontType"
        [style.font-size]="detailsStyles?.fontSize"
        [style.font-style]="detailsStyles?.fontStyle"
        class="idp-offer-card-content__details"
        data-cy="idp-offer-card-content-detail"
      >
        {{ details }}
      </p>
    </ng-container>
    <span
      *ngIf="config.showLinks"
      [ngClass]="{
        'idp-separator-margin--confirmation':
          !config.showCreditSummary && !config.congratulation
      }"
      [style.color]="linksStyles?.fontColor"
      [style.font-family]="linksStyles?.fontType"
      [style.font-size]="linksStyles?.fontSize"
      class="idp-offer-card-content__links"
    >
      <idp-tab-navigation
        (selectedTab)="changeTab($event)"
        [tabList]="links"
        data-cy="idp-offer-card-tab-navigation"
      ></idp-tab-navigation>
    </span>
  </div>
</div>
